export default "__VITE_ASSET__DDGlrMth__"